import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getYear/index.js';

var require$$26 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$26 as default };
